import { de, enGB } from "date-fns/locale";

export const getDateFnsLocale = (locale: string) =>
  locale === "en" ? enGB : de;
